var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.195a1.845 1.845 0 11-.03-3.69 1.845 1.845 0 01.03 3.69zm0-2.81a.97.97 0 10-.03 1.94.97.97 0 00.03-1.94zM5.5 10.915A4.92 4.92 0 011.66 9.1l-.11-.135V8.79A2.445 2.445 0 014 6.54h3a2.445 2.445 0 012.42 2.25v.175l-.11.135a4.925 4.925 0 01-3.81 1.815zM2.46 8.69a4.065 4.065 0 006.05 0 1.565 1.565 0 00-1.5-1.275H4A1.56 1.56 0 002.46 8.69zM9.685 2H8.81v2.5h.875V2z",
    fill: "#121314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.81H8v.875h2.5V2.81z",
    fill: "#121314"
  })));
}
export default SvgSmall;